import Base from './Base'
import settings from '../Settings'
import { ExclamationTriangleFill, Globe } from 'react-bootstrap-icons'

class Carrier extends Base{
    static base_url = settings.BASE_API_URL + "carrier/"
    static columns = [{
        name: "id",
        label: "#",
    },
    {
        name: "name",
        label: "Jméno"
    },
    {
        name: "ico",
        label: "IČO"
    },
    {
        name: "town",
        label: "Město"
    },
    {
        name: "raal",
        label: "RAAL kód"
    },
    {
        name: 'blacklist',
        label: 'Černá listina',
        transform: value => !value ? null : <div className='text-danger'><ExclamationTriangleFill /> Na černé listině</div>
    }]

    label() {
        return this.name || `Dopravce ${this.id}`
    }

    static icon() {
        return Globe
    }
}

export default Carrier